import type { FC } from "react";
import { NavLink } from "react-router-dom";

export const UnassignedPlaceholder: FC = () => {
  return (
    <div className="vmx-page">
      <div className="vmx-card">
        <div className="vmx-empty">
          <div className="vmx-empty-icon">👤</div>
          <div className="vmx-empty-title">No customer assigned</div>
          <div className="vmx-empty-text">
            You need to be assigned to a customer to view data on this page. Go
            to the{" "}
            <NavLink to="/admin" style={{ color: "var(--vmx-accent)" }}>
              Admin portal
            </NavLink>{" "}
            to assign yourself.
          </div>
        </div>
      </div>
    </div>
  );
};
